export interface TipoDeMovimiento {
  id: string;
  nombre: string;
  descripcion: string;
  clase: string;
  titulo: string;
  texto: string;
  informe: string;
  proximo_paso: string;
  ppEnCuantosDias: number;
  estado: string;
}

export const tipoDeMtoInicial: TipoDeMovimiento = {
  id: '',
  nombre: '',
  descripcion: '',
  clase: '',
  titulo: 'SOLICITA',
  texto: 'Que vengo a solicitar',
  informe: '',
  proximo_paso: '',
  ppEnCuantosDias: 90,
  estado:''
};
